export const Fetch_sample_request = 'fetch_sample_request'
export const Fetch_sample_success = 'fetch_sample_success'
export const Fetch_sample_failure = 'fetch_sample_failure'
export const sample_table_off = 'sample_table_off'
